module.exports = __webpack_public_path__ + "img/nabe_sp.baad928e.jpg";